<ng-template #content let-modal>
    <div class="modal-body">
      <p>Please click on your business category questions</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary">Cancel</button>
      <button type="button" class="btn btn-primary">Submit</button>
    </div>
  </ng-template><div class="row p-4">
    <div class="col-md-12">
        <h3 class="text-center">New Business Registration</h3> 
        <h4 class="text-center">Questionnaire Selection</h4>       
    </div>
</div>
<div class="row">
    <div class="col-md-12 text-center">
        <label class="boldlbl"><span class="errorMsg">*</span>Please select either of the option.</label>
    </div>
</div> 
<div *ngIf="errorExist" id="alertRef" class="alert alert-danger fadein">
    <a href="#" class="close" data-dismiss="alert">&times;</a> <strong>Error!</strong>
    {{errorMessage}}
</div>  
<div class="text-center" >
    <div class="form-chcek-inline">
                     <input type="radio" name="question" class = "form-check-input ng-untouched ng-pristine ng-valid" id="fasttrackQuestions" 
                     (click)="select($event)" value="fasttrackQuestions">
                     <label class="form-check-label"or="fasttrackQuestions">FastTrack Questions</label>       
<br>
</div>
<br>

<div class="form-chcek-inline">
                     <input type="radio" name="question" class = "form-check-input ng-untouched ng-pristine ng-valid " id="normalQuestions"
                      (click)="select($event)" value="normalQuestions">
                     <label class="form-check-label"for="normalQuestions">Normal Questions</label>
   <br>                   
 </div> 
   </div>
                                             
    <br>                 
<div class="text-center">
       <input type="button" class="btn btn-primary" routerLink="/eappreg_criteria" value="Back"/>        
     
      <button type="submit" class="btn btn-primary" (click)="submit()">Accept and Proceed</button>                       
 </div>
 <div>
 <br>
 </div>

 